import { Link } from "@cappelendamm/design-system/react";
import NextLink from "next/link";
import { ReactNode } from "react";

const ProductLink = ({
  sku,
  children,
}: {
  sku?: string;
  children: ReactNode;
}) => {
  return (
    <Link
      as={NextLink}
      variant="menu"
      className="justify-start pl-0"
      prefetch={false}
      href={`/cart/items/${sku}`}
    >
      <div className="w-full">{children}</div>
    </Link>
  );
};

export default ProductLink;
